// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"adminlayout_mainHeader__3nuHJ"};